import { useState } from 'react';
import PropTypes from 'prop-types';
import { ModalDialog } from '@edx/paragon';
import { useIntl } from '@edx/frontend-platform/i18n';
import { reminderModalVariants } from './constants';
import messages from './messages';
import ArrowRight from '../../assets/ai/ArrowRight';
import CloseIcon from '../../assets/ai/CloseDarkIcon';

const AiReminderModal = ({ isOpen, isFirstShow, onClose, onSendMessage }) => {
  const { formatMessage } = useIntl();
  const [inputValue, setInputValue] = useState('');
  const [randomVariantId] = useState(
    () => reminderModalVariants[Math.floor(Math.random() * reminderModalVariants.length)],
  );

  const title = isFirstShow
    ? formatMessage(messages['tutor.reminderModal.firstShowTitle'])
    : formatMessage(messages[randomVariantId]);

  const handleSend = () => {
    const text = inputValue.trim();
    if (!text) return;
    setInputValue('');
    onSendMessage(text);
  };

  const handleKeyDown = e => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleSend();
    }
  };

  return (
    <ModalDialog
      title="Custom dialog"
      isOpen={isOpen}
      onClose={onClose}
      hasCloseButton={false}
      className="ai-reminder-modal tw-max-w-none tw-rounded-t-[32px] tw-px-4 tw-pb-4 tw-pt-6 md:tw-max-w-[658px] md:tw-rounded-[32px] md:tw-px-12 md:tw-py-10 xl:tw-mx-0 xl:tw-px-14"
    >
      <ModalDialog.Header className="tw-mb-8 tw-min-h-0 !tw-p-0 md:tw-mb-12">
        <div className="tw-mb-2 tw-flex tw-justify-between tw-gap-[20px]">
          <ModalDialog.Title className="tw-mr-0 !tw-text-[20px] tw-font-medium tw-tracking-tight">
            {title}
          </ModalDialog.Title>
          <button
            type="button"
            className="tw-flex tw-h-6 tw-w-6 tw-cursor-pointer tw-items-center tw-justify-center tw-rounded-full tw-transition tw-duration-300 tw-ease-in hover:tw-bg-gray-300 focus-visible:tw-outline-none md:tw-m-[-10px] md:tw-h-12 md:tw-w-12 md:tw-min-w-12"
            onClick={onClose}
          >
            <CloseIcon />
          </button>
        </div>
      </ModalDialog.Header>

      <ModalDialog.Body className="tw-bg-neutral-100">
        <div className="tw-relative tw-w-full">
          <input
            type="text"
            value={inputValue}
            onChange={e => setInputValue(e.target.value)}
            onKeyDown={handleKeyDown}
            placeholder={formatMessage(messages['tutor.reminderModal.inputPlaceholder'])}
            className="tw-h-[50px] tw-w-full tw-rounded-[8px] tw-border-[1px] tw-border-neutral-600 tw-py-4 tw-pl-4 tw-pr-12 tw-text-sm tw-outline-none focus:tw-border-mainPurple"
          />
          <button
            type="button"
            onClick={handleSend}
            className="tw-absolute tw-bottom-[9px] tw-right-2 tw-flex tw-h-8 tw-w-8 tw-items-center tw-justify-center tw-rounded-full tw-bg-mainPurple tw-p-2 hover:tw-opacity-90"
          >
            <ArrowRight />
            <span className="tw-sr-only">Відправити повідомлення ШІ помічнику</span>
          </button>
        </div>
      </ModalDialog.Body>
    </ModalDialog>
  );
};

AiReminderModal.propTypes = {
  isOpen: PropTypes.bool,
  isFirstShow: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onSendMessage: PropTypes.func.isRequired,
};

AiReminderModal.defaultProps = {
  isOpen: false,
  isFirstShow: false,
};

export default AiReminderModal;
